export default class AggregatedData {
  addToBasket = 0;
  session = 0;
  pageView = 0;
}
